import React from "react";

const PermissionControlPanel = ({ children }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>{children}</div>
    </div>
  );
};

export default PermissionControlPanel;
